// eslint-disable-next-line import/prefer-default-export
export const mutationTypes = {
	EDIT: 'edit',
	REPLY: 'reply',
	DELETE: 'delete',
	NEW: 'new',
};
